<template>
  <div class="c-mockup-tool">
    <div :class="{'blocker': true, 'blocker--block': $store.state.printToPdfInProgress}">
      <app-markup-areas
        configured-type="areas"
        :element="frontendBaseElement"
      />
      <base-loading
        v-if="$store.state.printToPdfInProgress"
        :overlay="true"
      />
    </div>
    <div class="c-alert__container">
      <base-alert
        v-for="(alert, key) in alerts"
        :id="key"
        :key="key"
        :alert-display="alert.display"
        :alert-text="alert.text"
        :alert-type="alert.type"
      />
    </div>
  </div>
</template>

<script>
import BaseAlert from '@/components/BaseAlert.vue'
import BaseLoading from '@/components/BaseLoading.vue';
import AppMarkupAreas from '@/components/AppMarkupAreas.vue';

export default {
  /**
   * Die Einstiegskomponente für das MockupTool. Dies ist die äußerste Datei, die alle anderen Elemente beinhaltet.
   * @displayName FrontendMockupTool
   */
  name: 'FrontendMockupTool',
  components: {
    AppMarkupAreas,
    BaseLoading,
    BaseAlert,
  },
  data() {
    return {
      config: JSON.parse(window.mockuptoolSettings.config),
      loading: false,
      frontendBaseElement: JSON.parse(window.mockuptoolSettings.content),
    }
  },
  computed: {
    alerts() {
      return this.$store.state.alerts;
    },
  }
}
</script>

<style lang="less">
.container.container--mockup-tool {
  max-width: 100%;
  width: 1470px ;
}

.breaking-free-element {
  color: #111;
  text-align: left;
  margin: 70px auto 50px;
  position: relative;

  @media (max-width: 991px) {
    padding: 0;
  }
}

.drag-area {
  outline: 2px dashed #d6e7f5;
  background-color: #fff;
  outline-offset: 5px;
  margin-bottom: 102px;
  border-radius: 5px;
  min-height: 44px;
  padding: 1rem 0;

  &:after {
    content: 'Bereiche hierherziehen';
    color: #d6e7f5;
    text-align: center;
    font-size: 1.6rem;
    display: block;
    margin: 1rem  0;
  }

  @media (max-width: 767px) {
    padding: 0.3rem 0;

    &:after, &:not(:empty):before {
      margin: 0.5rem 0;
      font-size: 1.3rem;
    }
  }

  &--highlight-drop-area,
  &:empty {
    outline-color: #0375a6;

    &:after,
    &:before {
      color: #0375a6;
    }
  }

  &:empty {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  &--printing {
    &:before,
    &:after {
      content: '' !important;
      display: none !important;
    }
  }

  @media (max-width: 991px) {
    margin-bottom: 50px;
  }
}

.ed_panel.panel.panel-default.ed_element_teaser {
  margin-bottom: 0;
}

.ghost-parent-area {
  .sortable-ghost {
    .panel {
      outline: none !important;
      margin-bottom: 15px;
    }

    .panel-footer {
      display: none !important;
    }

    &.col-lg-4 {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
    }

    max-width: 100% !important;
    width: 100% !important;

    * {
      opacity: 0.5;
    }

    .handle {
      height: auto;
      display: block;
    }

    img {
      opacity: 1 !important;
    }
  }
}

.handle {
  cursor: move;
}

.blocker {
  position: relative;

  &--block {
    pointer-events: none;

    & * {
      pointer-events: none;
    }

    &:after {
      content: '';
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999999999;
      background-color: #fff;
      opacity: 0.3;
    }
  }
}

//overwrites

.breaking-free-element {
  .item_groups {
    text-align: right;
  }

  .ed_element_fieldset_legend {
    font-size: 0.8rem;
    line-height: 1.3em;
    position: relative;
    z-index: 3;
    background-color: #fff;
  }

  .ed_element_fieldset {
    padding: 0 10px 10px;
    outline: 10px solid #fff;
    margin: 0 10px 10px 0;
  }

  .panel-title {
    font-size: 1rem;
  }

  .form {
    margin-bottom: 0;
  }

  img {
    display: block;
  }

  .panel-title {
    .item {
      border-radius: unset;
      height: 40px;
      min-width: 40px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }

  .text-right {
    text-align: right;
  }

  hr {
    border: #f5f5f5 1px solid;
    margin: 15px 0 10px;
  }
}

.c-mockup-tool {
  position: relative;
  z-index: 1;
}
</style>